import React from 'react';

import { IContentfulImage } from '../../interfaces/contentful-image.interface';
import { ILibraryMeetingPlace } from '../../queries/fragments/libraryMeetingPlace';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import LinkWrapper from '../ui/link-wrapper/link-wrapper';
import { HeaderOpeningHours } from './header-opening-hours';

interface HeaderProps {
  logo: IContentfulImage;
  meetingPlace: ILibraryMeetingPlace;
}
export const Header = ({ logo, meetingPlace }: HeaderProps) => {
  const aspectRatio =
    logo?.gatsbyImageData?.width && logo?.gatsbyImageData?.height
      ? logo.gatsbyImageData.width / logo.gatsbyImageData.height
      : undefined;
  return (
    <header className="absolute left-6 right-7 top-0 z-10 flex justify-between lg:right-28">
      <div className="grid w-full grid-cols-11 gap-5 lg:mt-6">
        <div className="col-span-11 w-fit pt-6 lg:col-span-8 lg:pt-3">
          <LinkWrapper
            data={`/${meetingPlace.node_locale.toLowerCase()}/`}
            className="relative block lg:ml-22"
          >
            <ImageWrapper
              className={aspectRatio == 1 ? 'max-h-14 w-36' : 'max-h-10 w-36'}
              alt={logo?.description ? logo.description : ''}
              file={logo?.file}
              gatsbyImageData={logo?.gatsbyImageData}
              svg={logo?.svg}
              imgClassName={
                aspectRatio == 1 ? 'max-h-14 !w-auto' : 'max-h-10 !w-auto'
              }
            />
            <div className="mt-3 font-title text-headingxs text-text-default lg:hidden">
              {meetingPlace.name}
            </div>
          </LinkWrapper>
        </div>
        {meetingPlace && (
          <div className="relative col-span-3 hidden lg:block">
            <LinkWrapper data={meetingPlace?.openingHoursLink}>
              <HeaderOpeningHours meetingPlace={meetingPlace} />
            </LinkWrapper>
          </div>
        )}
      </div>
    </header>
  );
};
